'use strict';
import axios from 'axios';
import getHeader from '../config/header';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Legal = {

    async getTerms() {
		try {
			const header = await getHeader();

            let response = await axios.get(API_URL + '/terms', header);
            
			return response.data;

		} catch(error) {
            return false;
		}
    },
    
    async getPrivacyPolicy() {
		try {
			const header = await getHeader();

            let response = await axios.get(API_URL + '/terms?type=privacy', header);
            
			return response.data;

		} catch(error) {
            return false;
		}
	},

	async updateTerms(type, terms) {
        try {
            if (!type || !terms) {
                return { error: 'A mandatory field is missing' };
            }

            const header = await getHeader();

            let response = await axios.post(API_URL + '/terms', {
                    "type": type,
					"terms": terms
                }, header);

            if (response.data.id) {
                return true;
			}
			
			return false;

        } catch(error) {
            return false;
        }
    }
    
}

export default Legal;
